import React from 'react';
import Chats from '../assets/images/chats.png';

const SelectChatIcon = (props) => (
    <img src={Chats} width={70} height={70}/>
);

export default SelectChatIcon;



// WEBPACK FOOTER //
// ./src/assets/SelectChatIcon.jsx